import {css} from "@emotion/react";

import {calculateRemSize} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {modalStepsDescriptions} from "../../constants/modal_steps_descriptions";

export const ForYouStepDescription = () => {
    const modalStep = useAppSelector((state) => state.forYouModal.step);
    const information = modalStepsDescriptions[modalStep];

    if (!information) {
        return null;
    }

    return (
        <div css={informationWrapper}>
            <Text variant="headline_6" as="p">
                {information.title}
            </Text>
            <Text variant="info_txt_1">{information.desc}</Text>
        </div>
    );
};

const informationWrapper = css`
    display: flex;
    gap: ${calculateRemSize(1)};
    flex-direction: column;
    align-items: start;
    justify-content: center;

    @media (min-width: ${getThemeBreakpoint().md}) {
        justify-content: start;
    }
`;
import {css} from "@emotion/react";

import {calculateRemSize} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {modalStepsDescriptions} from "../../constants/modal_steps_descriptions";

export const ForYouStepDescription = () => {
    const modalStep = useAppSelector((state) => state.forYouModal.step);
    const information = modalStepsDescriptions[modalStep];

    if (!information) {
        return null;
    }

    return (
        <div css={informationWrapper}>
            <Text variant="headline_6" as="p">
                {information.title}
            </Text>
            <Text variant="info_txt_1">{information.desc}</Text>
        </div>
    );
};

const informationWrapper = css`
    display: flex;
    gap: ${calculateRemSize(1)};
    flex-direction: column;
    align-items: start;
    justify-content: center;

    @media (min-width: ${getThemeBreakpoint().md}) {
        justify-content: start;
    }
`;
